import React, { useState, useEffect, useRef } from "react";
import { loadYandexMaps } from "../../utils/maps";

export const CreateTaskMap = ({ latitude, longitude, onLocationSelect, mapHeight }) => {
  const mapRef = React.useRef(null);
  const [mapInstance, setMapInstance] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!isInitialized) {
      initMap();
    }
  }, [isInitialized]);

  useEffect(() => {
    if (mapInstance && isInitialized) {
      updateMarker();
    }
  }, [latitude, longitude]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (mapInstance) {
        try { mapInstance.destroy(); } catch (error) {}
      }
    };
  }, [mapInstance]);

  const initMap = async () => {
    if (!mapRef.current || isInitialized) return;
    
    try {
      const ymaps = await loadYandexMaps();
      
      // Clear any existing map content
      if (mapRef.current) {
        mapRef.current.innerHTML = '';
      }
      
      const map = new ymaps.Map(mapRef.current, {
        center: [latitude, longitude],
        zoom: 13,
        controls: ['zoomControl'] // Убираем fullscreenControl
      });

      // Add click listener to map
      map.events.add('click', async (e) => {
        const coords = e.get('coords');
        const lat = coords[0];
        const lng = coords[1];
        
        console.log('Map clicked at:', lat, lng);
        
        // First update the marker immediately
        const placemark = new ymaps.Placemark(coords, {
          balloonContent: 'Выбранное место'
        }, {
          preset: 'islands#redIcon'
        });
        
        // Remove existing markers and add new one
        map.geoObjects.removeAll();
        map.geoObjects.add(placemark);
        
        // Call onLocationSelect immediately first
        if (onLocationSelect) {
          onLocationSelect(lat, lng, null);
        }
        
        // Try to get address from coordinates (reverse geocoding) in background
        try {
          const geocoder = ymaps.geocode(coords);
          const result = await new Promise((resolve) => {
            geocoder.then(resolve);
          });
          
          const firstGeoObject = result.geoObjects.get(0);
          const address = firstGeoObject ? firstGeoObject.getAddressLine() : null;
          
          console.log('Address found:', address);
          
          // Update with address if found
          if (onLocationSelect && address) {
            onLocationSelect(lat, lng, address);
          }
        } catch (error) {
          console.error('Reverse geocoding failed:', error);
          // onLocationSelect was already called above, so we don't need to call it again
        }
      });

      setMapInstance(map);
      setIsInitialized(true);
      
      // Add initial marker
      addMarker(map, ymaps);
      
    } catch (error) {
      console.error('Error initializing map:', error);
    }
  };

  const addMarker = (map, ymaps) => {
    if (!map || !ymaps) return;
    
    map.geoObjects.removeAll();
    
    // Add marker for current location
    const placemark = new ymaps.Placemark([latitude, longitude], {
      balloonContent: 'Выбранное место'
    }, {
      preset: 'islands#redIcon'
    });
    
    map.geoObjects.add(placemark);
  };

  const updateMarker = () => {
    if (!mapInstance) return;
    
    // Center map on new coordinates
    mapInstance.setCenter([latitude, longitude]);
    
    // Update marker
    loadYandexMaps().then(ymaps => {
      addMarker(mapInstance, ymaps);
    }).catch(error => {
      console.error('Error updating marker:', error);
    });
  };

  return (
    <div>
      <div 
        ref={mapRef} 
        className="w-full rounded-md border border-gray-300"
        style={{ background: '#f5f5f5', height: mapHeight || '256px' }}
      />
      <p className="text-xs text-gray-500 text-center mt-1">
        Кликните на карте для выбора точного местоположения
      </p>
    </div>
  );
};
